export const subscriptionApiErrorMessages = {
  currentBillingCycleStatusIsUnknown: 'Nästa beställningsdatum kan inte ändras',
  rebillInProgress: 'Nästa beställningsdatum kan inte ändras: omfakturering pågår',
  paymentFailed: 'Nästa beställningsdatum kan inte ändras: betalning misslyckades'
};
